module.exports = __webpack_public_path__ + "static/img/reviews.e308b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpg/reviews.jpg
// module id = 196
// module chunks = 0